import tv from '../images/img_tv.svg';
import channels from '../images/img_channels.svg';
import card from '../images/img_cc.svg';
import couch from '../images/img_sofa.svg';
import cvv from '../images/CVV_CVC.png';

export const advantages = [
  {
    image: tv,
    title: 'PRATICIDADE',
    content: 'Você não precisa mais se preocupar em recarregar todo mês!',
  },
  {
    image: channels,
    title: 'CANAIS EXTRAS',
    content: 'Ganhe todos os canais extras das promoções Recarregue e Ganhe.',
  },
  {
    image: card,
    title: 'SEM FATURA E SEM BOLETO',
    content: 'Direto no cartão de crédito, sem comprometer o limite do cartão.',
  },
  {
    image: couch,
    title: 'COMODIDADE',
    content: 'Não precisa mais ir até um ponto de recarga.',
  },
];

export const cvvHelp = {
  image: cvv,
  title: '',
  content:
    'Sequência numérica de três ou quatro dígitos, localizada na frente ou no verso do cartão de crédito.',
};
